
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "UserCommunication",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {    
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "Benutzer",
      page: "BenutzerKommunikation",
      remoteId: "",
      
      
    });

    return {
      request
    };
  }
};
